import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useFormContext } from "react-hook-form";

import { CalendarIcon, ListingType } from "../../../../assets";
import { EMPTY_STRING, listingTypes } from "../../../../constants";
import {
  dateToUnixTimestamp,
  unixTimestampToDate,
} from "../../../../shared/utility";

const ListingTypeCard = () => {
  const {
    setValue,
    watch,
    register,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const selectedDate = (key) => {
    const value = watch(key);
    return value ? unixTimestampToDate(value) : null; // Default to null if value is undefined
  };

  const handleDateChange = (date, key) => {
    setValue(key, date ? dateToUnixTimestamp(date) : null, {
      shouldValidate: true,
    });
  };

  const isOpenHouse = watch("openHouse");
  useEffect(() => {
    if (!isOpenHouse) {
      setValue("startDate", null);
      setValue("endDate", null);
      clearErrors("endDate");
      clearErrors("startDate");
    }
  }, [isOpenHouse]);

  return (
    <div className="create-form-card">
      <div className="form-card-heading">
        <img src={ListingType} alt="Listing Type Icon" />
        Listing Type
      </div>
      <div className="form-group">
        <div className="d-flex gap-3 gap-lg-5">
          {listingTypes.map((type) => (
            <Form.Check
              className="mb-0"
              {...register("listingType")}
              name="listingType"
              type="radio"
              label={type.label}
              value={type.id}
            />
          ))}
        </div>
        {errors.listingType && (
          <div className="error mt-2 w-100">{errors.listingType.message}</div>
        )}
        <div className="date-picker-container">
          <DatePicker
            className={`create-list-input date-input ${
              errors.availability ? "border border-danger" : EMPTY_STRING
            }`}
            toggleCalendarOnIconClick
            placeholderText="Availability"
            selected={selectedDate("availability")} // Use 'selected' instead of 'value'
            onChange={(date) => handleDateChange(date, "availability")}
            showIcon
            calendarIconClassName="calendar-icon"
            dateFormat="yyyy/MM/dd"
            icon={<img src={CalendarIcon} alt={EMPTY_STRING} />}
          />
        </div>
        <div className="custom-checkbox mt-4">
          <Form.Check
            label="Open House"
            name="openHouse"
            type="checkbox"
            checked={isOpenHouse}
            onChange={(e) => setValue("openHouse", e.target.checked)}
          />
        </div>
        {isOpenHouse && (
          <div className="date-picker-container">
            <DatePicker
              className={`create-list-input date-input ${
                errors.startDate ? "border border-danger" : EMPTY_STRING
              }`}
              toggleCalendarOnIconClick
              placeholderText="Start Date"
              selected={selectedDate("startDate")} // Use 'selected' instead of 'value'
              onChange={(date) => handleDateChange(date, "startDate")}
              showIcon
              calendarIconClassName="calendar-icon"
              dateFormat="yyyy/MM/dd"
              icon={<img src={CalendarIcon} alt={EMPTY_STRING} />}
            />
            <DatePicker
              className={`create-list-input date-input ${
                errors.endDate ? "border border-danger" : EMPTY_STRING
              }`}
              toggleCalendarOnIconClick
              placeholderText="End Date"
              selected={selectedDate("endDate")} // Use 'selected' instead of 'value'
              onChange={(date) => handleDateChange(date, "endDate")}
              showIcon
              calendarIconClassName="calendar-icon"
              dateFormat="yyyy/MM/dd"
              icon={<img src={CalendarIcon} alt={EMPTY_STRING} />}
            />
            <span className="text-danger mt-1">
              {errors.endDate?.message !== EMPTY_STRING
                ? errors.endDate?.message
                : EMPTY_STRING}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListingTypeCard;
